import type { HuntDebug } from '../render/habitats/hunts';

/**
 * The developer's view of the Reef's hunts (M251, the brief's section 11: "an optional developer debug overlay ...
 * Disable this information in normal gameplay"): each strike under way, its predator and prey, its stage, the
 * predator's mouth and where its strike ends, how it ends, and how long it takes. Mounted only in the developer's mode
 * (`?dev`), shown with `?huntoverlay` or `seaHunts.overlay()`; its text is `huntOverlayText`'s, the one function the
 * tests read.
 */
export function huntOverlayText(hunts: readonly HuntDebug[]): string {
  if (hunts.length === 0) return 'Hunts: none under way';
  const at = (v: readonly [number, number, number]): string => v.map((x) => x.toFixed(2)).join(', ');
  return hunts.map((h) => `${h.predator} → ${h.prey} (${h.staged}): ${h.state}, ${h.outcome}, ${h.elapsedS.toFixed(2)} of ${h.durationS.toFixed(2)} s\n  mouth ${at(h.mouth)}\n  to ${at(h.destination)}`).join('\n');
}

export interface HuntOverlay {
  shown(): boolean;
  toggle(on: boolean): void;
  show(hunts: readonly HuntDebug[]): void;
}

export function mountHuntOverlay(parent: HTMLElement, visible: boolean): HuntOverlay {
  const node = document.createElement('pre');
  node.className = 'hunt-overlay';
  // A diagnostic, as the frame meter is: hidden from assistive technology.
  node.setAttribute('aria-hidden', 'true');
  node.hidden = !visible;
  parent.appendChild(node);
  let painted = '';
  return {
    shown: () => !node.hidden,
    toggle(on: boolean): void {
      node.hidden = !on;
    },
    show(hunts: readonly HuntDebug[]): void {
      if (node.hidden) return;
      const text = huntOverlayText(hunts);
      if (text !== painted) node.textContent = painted = text;
    },
  };
}
